module.exports = __webpack_public_path__ + "img/441-972c5f.png";